// utils/formHelpers.js
// Helpers compartidos por todos los formularios (Req 2026-05-13).

/**
 * Bloquea el submit accidental de un formulario al presionar Enter en un
 * <input>. Permite el Enter dentro de <textarea> (para saltos de línea) y
 * sobre botones de tipo "submit" (click intencional del usuario).
 *
 * Uso:
 *   <form onSubmit={handleSubmit} onKeyDown={preventEnterSubmit}>
 *
 * Si necesitas un comportamiento adicional al Enter (ej. agregar item en una
 * tabla dinámica) define tu propio handler y compone:
 *   const onKeyDown = (e) => { preventEnterSubmit(e); miHandler(e); };
 */
export const preventEnterSubmit = (e) => {
  if (e.key !== "Enter") return;
  const tag = e.target.tagName;
  const type = e.target.type;
  // Enter permitido en textareas y en botones submit (cuando el botón está
  // enfocado y el usuario presiona Enter sobre él).
  if (tag === "TEXTAREA") return;
  if (tag === "BUTTON" && type === "submit") return;
  e.preventDefault();
};

/**
 * Clases de Tailwind estandarizadas para los botones del pie de cada Form.
 * Las exportamos como constantes para evitar copy/paste y permitir cambios
 * centralizados de estilo.
 */
export const FORM_FOOTER_CONTAINER =
  "flex justify-end items-center gap-3 mt-6 pt-4 border-t border-blueGray-200";

export const FORM_BTN_CANCEL =
  "px-5 py-2.5 border border-blueGray-300 text-blueGray-700 rounded-lg " +
  "font-display font-semibold hover:bg-blueGray-100 " +
  "disabled:opacity-50 disabled:cursor-not-allowed transition-colors";

export const FORM_BTN_SUBMIT =
  "px-5 py-2.5 bg-quantus-blue-500 text-white rounded-lg " +
  "font-display font-semibold hover:bg-quantus-blue-600 shadow-quantus " +
  "disabled:opacity-50 disabled:cursor-not-allowed transition-colors";
